/*
----------------------------------------------------------------------------------------------------------------------------------

# DESCRIPTION
This script contains the boot loader for takeover ads at Tradera. In the current version it has support for following vendors:
- Leeads

IMPORTANT: if you need to add a new takeover solution then be sure it doesn't collide with the leeads takeover solution. 
There is a risk you get a take over over a take over if that happens.

----------------------------------------------------------------------------------------------------------------------------------
*/

import { getInitData } from 'packages/init-data';
import { BREAKPOINTS, isBreakpointOrHigher } from 'tradera-utils/breakpoints';
import GdprSettings from 'tradera-utils/gdpr-settings';

/**
 * this will be false if the user has an ad blocker
 */
const adTechLoaded = () => {
    return typeof window.ADTECH === 'undefined' ? false : true;
};

/**
 * init the leeads desktop take over
 * @param {*DOMElement} takeoverElement
 */
const initLeeadsDesktop = takeoverElement => {
    // console.info('[init] leeads take over - desktop');

    // <!-- Async Tag // Tag for network 1568: Leeads // Website: Leeads AB | Intressesajt | Tradera - HTTPS // Page: Tradera // Placement: Tradera - Helsida 1x1 - Desktop (6498025) // created at: Jan 24, 2018 2:02:50 PM -->
    if (takeoverElement.children.length == 0) {
        takeoverElement.innerHTML =
            '<div id="6498025" data-ads-leeads-takeover=""><noscript><a href="https://adserver.adtech.de/adlink|3.0|1568.1|6498025|0|16|ADTECH;loc=300;alias=" target="_blank"><img src="https://adserver.adtech.de/adserv|3.0|1568.1|6498025|0|16|ADTECH;loc=300;alias=" border="0" width="1" height="1"></a></noscript></div>';
    }
    window.ADTECH.config.page = {
        protocol: 'https',
        server: 'adserver.adtech.de',
        network: '1568.1',
        siteid: '894854',
        params: { loc: '100' }
    };
    window.ADTECH.config.placements[6498025] = {
        sizeid: '16',
        params: { alias: '', target: '_blank' }
    };
    window.ADTECH.enqueueAd(6498025);
    window.ADTECH.executeQueue();
};

const isTakeOverAllowedOnPage = () => {
    let initData = getInitData();
    switch (initData.pageName) {
        case 'StartPage':
        case 'Category':
        case 'SearchResults':
            return true;
        default:
            return false;
    }
};

const loadScript = src => {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.src = src;
        script.async = false;
        script.onload = () => {
            resolve();
        };
        script.onerror = () => {
            reject('failed to load adtech script');
        };
        document.body.appendChild(script);
    });
};

const initTakeovers = async () => {
    if (!GdprSettings.isMarketingEnabled()) {
        return;
    }
    try {
        await loadScript('https://aka-cdn.adtech.de/dt/common/DAC.js');
    } catch (err) {
        // failed, maybe adblocker or other, do not do anything more here
        return;
    }

    if (!adTechLoaded()) {
        return;
    }

    if (!isTakeOverAllowedOnPage()) {
        return;
    }

    let takeoverElement = document.getElementById('ads-takeover');
    let clientWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );

    // LEEADS TAKEOVERS
    if (isBreakpointOrHigher(BREAKPOINTS.MD, clientWidth)) {
        initLeeadsDesktop(takeoverElement);
    }
};

export default initTakeovers;
